import { observer } from 'mobx-react-lite';
import React from 'react';
import { bookingSummaryState, useBookingSummaryState } from '#/components/BookingSummaryPanel/BookingSummaryContext';
import { StackedDrawerWrap } from '#/components/StackedDrawerWrap';
import { useCanEditSelectedReservation } from '#/hooks/useCanEditSelectedReservation';
import { useIsSmallView } from '#/hooks/useIsSmallView';
import { formatBookingNumber } from '#/hooks/useRefToBookingNumber';
import { amendmentStore } from '#/stores/amendmentStore';
import { RentalsReservationInstance } from '@jucy-nakuru/common/services/JucyRentalsApi/RentalsReservation';
import { IconButtonProps } from '@mui/material';
import BookingSummaryPanelContent from './BookingSummaryPanelContent';

interface SummaryPanelProps {
    reservation?: RentalsReservationInstance;
    showEdit?: boolean;
    closeButtonProps?: IconButtonProps<React.ElementType>;
}

const BookingSummaryPanel: React.FC<SummaryPanelProps> = observer(function BookingSummaryPanelComponent({
    reservation,
    showEdit = false,
    closeButtonProps,
}) {
    const isSm = useIsSmallView();
    useBookingSummaryState({
        collapsable: isSm,
        isPartnerBooking: !reservation?.isWebAccount,
    });
    const isEditable = useCanEditSelectedReservation(showEdit);

    if (!reservation) {
        return null;
    }

    const amendment = amendmentStore.amendments.find((r) => r.reference === reservation?.reservationReference);
    if (!isSm) {
        return <BookingSummaryPanelContent reservation={reservation} showEdit={showEdit} amendment={amendment} />;
    }

    const title = isEditable ? `Edit Booking Number: ${formatBookingNumber(reservation)}` : `Trip Summary  ${formatBookingNumber(reservation)}`;

    return bookingSummaryState.open ? (
        <StackedDrawerWrap
            closeButtonProps={closeButtonProps}
            onClose={() => {
                bookingSummaryState.setOpen(false);
            }}
            title={title}
        >
            <BookingSummaryPanelContent reservation={reservation} showEdit={showEdit} amendment={amendment} />
        </StackedDrawerWrap>
    ) : null;
});

export default BookingSummaryPanel;
